export const ControlledTuningIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 4.5C4.05964 4.5 3.5 5.05964 3.5 5.75V16.25C3.5 16.9404 4.05964 17.5 4.75 17.5H19.25C19.9404 17.5 20.5 16.9404 20.5 16.25V5.75C20.5 5.05964 19.9404 4.5 19.25 4.5H4.75ZM2 5.75C2 4.23122 3.23122 3 4.75 3H19.25C20.7688 3 22 4.23122 22 5.75V16.25C22 17.7688 20.7688 19 19.25 19H15.9943L16.7211 21.544C16.8349 21.9422 16.6043 22.3573 16.206 22.4711C15.8078 22.5849 15.3927 22.3543 15.2789 21.956L14.4343 19H9.56573L8.72114 21.956C8.60735 22.3543 8.19224 22.5849 7.79396 22.4711C7.39568 22.3573 7.16506 21.9422 7.27886 21.544L8.0057 19H4.75C3.23122 19 2 17.7688 2 16.25V5.75ZM12 7C12.4142 7 12.75 7.33579 12.75 7.75V14.25C12.75 14.6642 12.4142 15 12 15C11.5858 15 11.25 14.6642 11.25 14.25V7.75C11.25 7.33579 11.5858 7 12 7ZM16.25 10C16.6642 10 17 10.3358 17 10.75V14.25C17 14.6642 16.6642 15 16.25 15C15.8358 15 15.5 14.6642 15.5 14.25V10.75C15.5 10.3358 15.8358 10 16.25 10ZM7.75 12C8.16421 12 8.5 12.3358 8.5 12.75V14.25C8.5 14.6642 8.16421 15 7.75 15C7.33579 15 7 14.6642 7 14.25V12.75C7 12.3358 7.33579 12 7.75 12Z"
        fill="#737373"
      />
    </svg>
  );
};
